import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, post } from '@api/request';
import { mdtfAPI } from '@api/modules/mdtf';
import { optnAPI } from '@api/modules/optn';
import addHeader from '@/views/component/addHeader';
import inputUser from '@/views/component/inputUser';
import { mqcdAPI } from '@api/modules/mqcd';
export default {
  name: 'mdtfAddMain',
  components: {
    addHeader: addHeader,
    inputUser: inputUser
  },
  data: function data() {
    return {
      mdtfForm: {
        mdtf_type: null,
        qrcd_no: null,
        mdrl_id: null,
        mdrl_no: null,
        mdrl_name: null,
        mdrl_unit: null,
        mdrl_type: null,
        mdrl_num: null,
        mdrl_width: null,
        mdrl_color: null,
        mdrl_spec: null,
        qrcd_bin: null,
        user_id: null,
        stff_id: null,
        dept_id: null,
        status: 0,
        key: 0,
        belo_dept_id: null
      },
      binList: [],
      mdrlType: [{
        id: 1,
        label: '钢材'
      }, {
        id: 2,
        label: '辅材'
      }],
      mdrlTypeGroupOpt: [],
      title: '',
      binFlag: false,
      numFlag: false,
      mdrlType1: '原面料',
      mdrlType2: '辅料',
      mdrlType3: '包材',
      mdrlType4: '',
      disableFlag: false,
      option: [] //打样部门

    };
  },
  watch: {},
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {
    this.$refs.inputs.focus();
  },
  methods: {
    initData: function initData() {
      this.getMdtfType();
      this.getBinList();
      this.getDepartment();
    },
    // 获取库位信息
    getBinList: function getBinList() {
      var _this = this;

      get(optnAPI.getAllContent, {
        perm_id: 10006
      }).then(function (res) {
        if (res.data.code === 0) {
          _this.binList = res.data.data;
        } else {
          var mg = res.data.msg;
          var tp = 'error';

          _this.$message({
            message: mg,
            type: tp
          });
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this.$message({
          message: mg,
          type: tp
        });
      });
    },
    // 获取单位
    getMdtfType: function getMdtfType() {
      var _this2 = this;

      get(optnAPI.getAllContent, {
        perm_id: 10005
      }).then(function (res) {
        if (res.data.code === 0) {
          _this2.mdrlTypeGroupOpt = res.data.data;
        }
      }).catch(function (res) {
        var mg = res.data.msg;
        var tp = 'error';

        _this2.$message({
          message: mg,
          type: tp
        });
      });
    },
    //获取打样部门
    getDepartment: function getDepartment() {
      var _this3 = this;

      get(optnAPI.getOptnByPermId, {
        perm_id: 10009
      }).then(function (res) {
        if (res.data.code === 0) {
          var arr = [];
          res.data.data.form.optn_cntt_list.forEach(function (item) {
            arr.push({
              value: item.param2,
              label: item.param1
            });
          });
          _this3.option = arr;
          return;
        }

        _this3.$message.error(res.data.msg);
      });
    },
    //提交表单
    submit: function submit(formName) {
      var _this4 = this;

      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$refs[formName].validate(function (valid) {
          if (valid) {
            _this4.saveInfo();
          } else {
            console.log('error submit!');
            return false;
          }
        });
      }).catch(function () {});
    },
    // 保存入库
    saveInfo: function saveInfo() {
      var _this5 = this;

      var staffForm = this.$refs.userData.getData();
      this.mdtfForm.mdtf_type = 0;
      this.mdtfForm = Object.assign(this.mdtfForm, staffForm);
      post(mdtfAPI.stockIn, this.mdtfForm).then(function (res) {
        if (res.data.code === 0) {
          _this5.$message({
            type: 'success',
            message: '保存成功'
          });

          _this5.disableFlag = false; //清空二维码

          _this5.$EventBus.$emit('uploading', 12345);

          var permId = _this5.$route.query.perm_id;

          _this5.jump("/mdtf_list?perm_id=".concat(permId));

          _this5.resetForm('mdtfForm');

          _this5.$refs.inputs.focus();
        } else if (res.data.code === 7) {
          _this5.$message({
            type: 'error',
            message: '库位中已有此材料'
          });
        } else {
          _this5.initData();
        }
      }).catch(function () {
        _this5.$message({
          type: 'error',
          message: '请输入正确的二维码编号'
        });

        _this5.resetForm('mdtfForm');
      });
    },
    //取消
    cancel: function cancel() {
      var _this6 = this;

      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(function () {
        _this6.resetForm('mdtfForm');

        _this6.$router.go(-1);

        _this6.$message({
          type: 'info',
          message: '已取消新增!'
        });
      });
    },
    // 扫码按下enter键导入材料
    inputDown: function inputDown() {
      var _this7 = this;

      if (!this.mdtfForm.qrcd_no) {
        return this.$message.warning('请先输入二维码编号');
      }

      this.$refs.inputs.blur();
      get(mqcdAPI.getMqcdById, {
        mqcd_no: this.$refs.inputs.$options.propsData.value
      }).then(function (res) {
        if (res.data.code === 0) {
          _this7.disableFlag = true;

          _this7.mdrlImport(res.data.data.form);
        } else if (res.data.code === 7) {
          _this7.$message({
            type: 'error',
            message: '库位中已有此材料'
          });
        } else {
          _this7.initData();
        }
      });
    },
    // 清空
    emptyInput: function emptyInput() {
      this.resetForm('mdtfForm');
      this.disableFlag = false;
    },
    // 材料入库导入
    mdrlImport: function mdrlImport(val) {
      var no = this.mdtfForm.qrcd_no;
      this.mdtfForm = val;
      this.mdtfForm.qrcd_no = no;

      if (val.mqcd_bin) {
        this.binFlag = true;
        this.mdtfForm.mqcd_bin = val.mqcd_bin;
      } else {
        this.binFlag = false;
        this.mdtfForm.mqcd_bin = null;
      }
    },
    //表单重置
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.mdtfForm.mqcd_bin = null;
      this.binFlag = false;
      this.addNum = null;
    }
  }
};